export enum Endpoints {
    /**
     * Public module
     */
    // Pages
	PublicPage = '/pages/:slug',

    // User
    PublicUsersPassword = '/users/password',

    // Companies
    PublicCompanyRegister = '/companies',

}

export interface ListParamsDefault {
    page?: number;
    perPage?: number;
    search?: string;
}